import qs from "query-string";
import { Outlet, RouteObject } from "react-router-dom";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";
import { BulkImportPage, NotFound, RouteError, UserAccountInvite } from "@/components/pages";
import { Public } from "@/containers";
import { authRoutes } from "./auth";
import { clientRoutes } from "./client";
import { embedRoutes } from "./embed";
import { kindeRoutes } from "./kinde";
import { privateRoutes } from "./private";
import { RequireAuth } from "./RequireAuth/RequireAuth";
import { publicRoutes } from "./public";

export const routes: RouteObject[] = [
  {
    path: "/",
    element: (
      <QueryParamProvider
        adapter={ReactRouter6Adapter}
        options={{
          searchStringToObject: qs.parse,
          objectToSearchString: qs.stringify,
        }}
      >
        <Outlet />
      </QueryParamProvider>
    ),
    children: [
      // User account invite - MUST be first to take priority over authRoutes invite/:token
      // Note: path is "invite/:inviteKey" (relative) because basename is "/dashboard"
      {
        path: "invite/:inviteKey",
        element: <UserAccountInvite />,
      },
      // Embed routes - for iframe embedding on external websites (no auth required)
      /*
       * A finished bulk import, linked from its completion email (DEV-1215).
       *
       * Sits ABOVE the portal route trees on purpose. An import can be started by a client, an
       * assistant or an operator, and those live behind different guards — one email cannot carry
       * three links. Authentication only; the server decides who may read a given import.
       */
      {
        path: "bulk-import/:bulkId",
        element: <RequireAuth />,
        errorElement: <RouteError />,
        children: [{ index: true, element: <BulkImportPage /> }],
      },
      embedRoutes,
      publicRoutes,
      ...kindeRoutes,
      clientRoutes,
      privateRoutes,
      {
        path: "/",
        element: <Public />,
        errorElement: <RouteError />,
        children: [
          ...authRoutes,
          {
            path: "404",
            element: <NotFound />,
          },
          {
            path: "*",
            element: <NotFound />,
          },
        ],
      },
    ],
  },
];
